const NOW_STATUSES: string[] = ['pending', 'waiting', 'missed', 'hold', 'serving'];
const PAST_STATUSES: string[] = ['completed', 'skipped', 'autoskipped', 'skip upon check-in'];
const PATIENT_WAITING_COUNT: string[] = ['NA', '-1', '-2', '-3', '-4'];

const NN_PLANNED = 'planned';
const WH_ORG = 'WHPL';
const INSTITUTION_NAME_OVERRIDE_ORGS: string[] = ['JCH'];
// Institutions that run on another institution's queue system (key: appointment org, value: queue system org).
// Queue APIs (eg. checkin, kiosk questionnaire) keep the appointment org as Organization and send the
// queue system org as OrganizationUnit so the backend routes to the correct queue system.
const QUEUE_SYSTEM_ORG_OVERRIDES: Record<string, string> = { JCH: 'NTFGH' };

/**
 * Organization to send on queue APIs. Institutions that run on another institution's queue system
 * (eg. JCH) keep their own org as Organization for barcode identity; everything else uses the
 * provided fallback (eg. the today-appointment org).
 */
const getQueueOrganization = (organization: string | undefined, fallbackOrganization: string | undefined): string =>
  (organization && QUEUE_SYSTEM_ORG_OVERRIDES[organization] ? organization : fallbackOrganization) ?? '';

/**
 * OrganizationUnit to send on queue APIs. For institutions that run on another institution's queue
 * system (eg. JCH), this resolves to the queue system org (eg. NTFGH) for routing; everything else
 * uses the provided fallback (eg. the appointment's own OrganizationUnit).
 */
const getQueueOrganizationUnit = (
  organization: string | undefined,
  fallbackOrganizationUnit: string | undefined
): string => (organization ? QUEUE_SYSTEM_ORG_OVERRIDES[organization] : undefined) ?? fallbackOrganizationUnit ?? '';

export {
  getQueueOrganization,
  getQueueOrganizationUnit,
  INSTITUTION_NAME_OVERRIDE_ORGS,
  NN_PLANNED,
  NOW_STATUSES,
  PAST_STATUSES,
  PATIENT_WAITING_COUNT,
  QUEUE_SYSTEM_ORG_OVERRIDES,
  WH_ORG,
};

export const QUESTIONNAIRE_NHGP_BLOCK_MSG_CODE = 'Appointment.MobileReg.Questionnaire.BlockMessage';

export const MOBILEREG_VC_PAYMENT_AMOUNT_THRESHOLD_CODE = 'Appointment.Configuration.VCPaymentAmountThreshold';
export const MOBILEREG_VC_PAYMENT_INSTITUTION_CODE_MAPPING =
  'Appointment.Configuration.VCPaymentInstitutionCodeMapping';

export const MOBILEREG_IHA_TUTORIAL_DAYS_THRESHOLD_CODE = 'MobileReg.Configuration.IHATutorialThresholdDays';
export const MOBILEREG_IHA_TUTORIAL_INSTITUTIONS_CODE = 'MobileReg.Configuration.IHATutorialInstitutions';
